import type { LeagueSummary, Schemas } from "@softmax/observatory-client/types";
import {
  curatedCoworldKeys,
  curationOn,
  normalizeCoworldKey,
} from "../coworlds";
import { watchableLeagues } from "../leagues";
import { featuredCoworlds } from "./site-shape";
import { publicRead } from "../data/public-api";

export function listedGamePage({
  cursor,
  signal,
}: {
  cursor: string | null;
  signal?: AbortSignal | undefined;
}) {
  const params = new URLSearchParams({ limit: "12" });

  for (const name of featuredCoworlds)
    params.append("preferred_coworld_key", normalizeCoworldKey(name));

  if (curationOn())
    for (const key of curatedCoworldKeys)
      params.append("game_of_week_coworld_key", key);

  if (cursor !== null) params.set("cursor", cursor);

  return publicRead<Schemas["ListedGameCatalogPage"]>({
    path: `/v2/leagues/catalog/games?${params}`,
    signal,
  });
}

export async function navigationLeagues({
  signal,
}: {
  signal?: AbortSignal | undefined;
} = {}): Promise<LeagueSummary[]> {
  const params = new URLSearchParams({ limit: "12" });

  for (const name of featuredCoworlds)
    params.append("preferred_coworld_key", normalizeCoworldKey(name));

  if (curationOn())
    for (const key of curatedCoworldKeys) {
      params.append("coworld_key", key);
      params.append("game_of_week_coworld_key", key);
    }

  const page = await publicRead<Schemas["ListedGameCatalogPage"]>({
    path: `/v2/leagues/catalog/games?${params}`,
    signal,
  });

  if (curationOn() && page.next_cursor !== null)
    throw new Error("Navigation catalog exceeded its selected games");

  return watchableLeagues(page.leagues);
}
